import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import { useEffect } from 'react';
import { NavMarker } from 'react-rhumb';
import UIErrorMessage from 'UIComponents/error/UIErrorMessage';
import ErrorMessage from '../alerts/ErrorMessage';
import LoginLoading from '../shared/LoginLoading';
import ReturnLink from '../shared/ReturnLink';
import { ERROR_COPY, LOADING_COPY, PAGE_HEADER } from './loginTypeConstants';
import { useConfirmationLanding } from './useConfirmationLanding';

const LoginConfirmationLanding = ({
  loginType = 'MICROSOFT'
}) => {
  const {
    error,
    onLoad
  } = useConfirmationLanding(loginType);
  useEffect(() => {
    onLoad();
  }, [onLoad]);
  return /*#__PURE__*/_jsx(NavMarker, {
    name: PAGE_HEADER[loginType],
    children: /*#__PURE__*/_jsx("div", {
      className: "text-center",
      children: error ? /*#__PURE__*/_jsxs(UIErrorMessage, {
        illustration: "errors/general",
        title: /*#__PURE__*/_jsx("h1", {
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: ERROR_COPY[loginType].header
          })
        }),
        children: [/*#__PURE__*/_jsx("div", {
          className: "m-bottom-4",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: ERROR_COPY[loginType].instructions
          })
        }), /*#__PURE__*/_jsx(ErrorMessage, {
          error: error
        }), /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: ERROR_COPY[loginType].navigate,
          options: {
            link: /*#__PURE__*/_jsx(ReturnLink, {})
          }
        })]
      }) : /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(LoginLoading, {
          message: LOADING_COPY[loginType].loadingMessageType
        }), /*#__PURE__*/_jsx(FormattedMessage, {
          message: LOADING_COPY[loginType].confirming
        })]
      })
    })
  });
};

export default LoginConfirmationLanding;